/*
 * @Description: 服务详情
 * @Author: webJ
 */
import ajax from '../http/ajax'

/**
 * 获取服务详情
 * @param {*} params 参数
 */
export const getServiceDetail = params => {
    return ajax.get('getServiceDetail', params)
}

export const sendTipsStore = params => {
    return ajax.get('sendTipsStore', params)
}
export const getServiceCouponList = params => {
    return ajax.get('getServiceCouponList', params)
}
